import { render, staticRenderFns } from "./OrdersCollection.vue?vue&type=template&id=2ee2e22a&"
import script from "./OrdersCollection.vue?vue&type=script&lang=js&"
export * from "./OrdersCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports